var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3288 12.1724C18.1563 12.3461 18.1376 12.5774 18.2763 12.868C18.4119 13.158 18.7026 13.5218 19.1457 13.9593C19.5882 14.3955 19.9569 14.683 20.2519 14.8199C20.5488 14.9561 20.7826 14.9361 20.9538 14.7624C21.2844 14.428 21.0101 13.8268 20.1313 12.9599C19.2582 12.0999 18.6576 11.8368 18.3288 12.1724Z",
    fill: "#031B76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5469 -0.00195312L0 17.5474L12.4544 29.9999L30.0019 12.4512V0.00179688L17.5469 -0.00195312ZM13.6856 18.183C13.1194 18.7593 12.4731 19.0005 11.75 18.9043C11.0281 18.8118 10.2756 18.3793 9.495 17.6087C7.90188 16.0362 7.69812 14.6487 8.88562 13.4462C9.46625 12.8568 10.1194 12.6087 10.8438 12.7005C11.5681 12.7924 12.3144 13.2174 13.0825 13.9743C13.8837 14.7655 14.3331 15.5149 14.43 16.2218C14.5256 16.9305 14.2775 17.5843 13.6856 18.183ZM16.5744 21.1662L13.1138 9.38055L14.3525 8.12492L17.8119 19.9124L16.5744 21.1662ZM22.0213 15.8368C21.4531 16.4112 20.8075 16.6543 20.0844 16.558C19.3619 16.4649 18.6112 16.0349 17.8331 15.2674C16.24 13.6949 16.0369 12.3074 17.2231 11.1037C17.805 10.5149 18.4581 10.2662 19.1831 10.3587C19.9062 10.4505 20.6537 10.8749 21.42 11.6318C22.2188 12.4193 22.6656 13.1687 22.7625 13.8755C22.86 14.5837 22.6131 15.238 22.0213 15.8368ZM26.67 5.96992C25.9412 6.69805 24.7606 6.69805 24.0294 5.97117C23.3012 5.24055 23.3013 4.0593 24.0281 3.32867C24.7581 2.59992 25.9419 2.59992 26.67 3.32742C27.4006 4.05992 27.4019 5.2393 26.67 5.96992Z",
    fill: "#031B76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98868 14.5131C9.81556 14.6881 9.79806 14.9206 9.93618 15.21C10.0724 15.5 10.3631 15.8637 10.8056 16.3019C11.2481 16.7387 11.6168 17.025 11.9124 17.1612C12.2074 17.2987 12.4424 17.28 12.6143 17.105C12.9431 16.7706 12.6699 16.1694 11.7918 15.3019C10.9193 14.4419 10.3181 14.18 9.98868 14.5131Z",
    fill: "#031B76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV3);
export default __webpack_public_path__ + "static/media/v3.7143d75ef60f1b59f5103b39b51e817f.svg";
export { ForwardRef as ReactComponent };